<template>
  <v-card flat>
    <v-app-bar
      absolute
      color="white"
      elevate-on-scroll
      scroll-target="#scrolling-techniques-7"
    >
      <v-toolbar-title class="hidden-sm-and-down ml-5">
        Users
      </v-toolbar-title>
    </v-app-bar>

    <v-card-text>
      <v-sheet
        v-resize="onResize"
        :height="height"
        id="scrolling-techniques-7"
        class="overflow-y-auto"
      >
        <v-container style="margin-top: 70px; margin-bottom: 70px; padding: 0;">
          <v-card>
            <v-virtual-scroll
              :bench="benched"
              :items="users"
              :height="height - 140"
              item-height="64"
            >
              <template v-slot:default="{ item }">
                <v-list-item :key="item.id">
                  <v-list-item-content>
                    <v-list-item-title>
                      <strong>
                        {{ item.firstName }} {{ item.lastName }}
                      </strong>
                    </v-list-item-title>
                    <v-list-item-subtitle
                      v-html="item.email"
                    ></v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-btn
                      v-if="item.status"
                      icon
                      @click.stop="editUser(item.id)"
                    >
                      <v-icon color="primary">mdi-pencil</v-icon>
                    </v-btn>

                    <v-btn
                      v-else
                      depressed
                      class="red lighten-1"
                      dark
                      @click="userStatus(item.id, true)"
                    >
                      Inactive
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>

                <v-divider></v-divider>
              </template>
            </v-virtual-scroll>
          </v-card>
        </v-container>
      </v-sheet>
    </v-card-text>

    <UserForm :visible="showUserForm" :item="user" @close="closeThis" />

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :multi-line="true"
      :timeout="6000"
    >
      {{ snackbar.message }}
      <v-btn dark text @click="snackbar.show = false">
        Close
      </v-btn>
    </v-snackbar>
    <v-btn
      class="mx-2"
      fab
      dark
      absolute
      right
      color="indigo"
      style="bottom: 40px;"
      @click="addUser()"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
  </v-card>
</template>

<script>
import Api from '@/services/Api'
import _ from 'lodash'
import UserForm from '../components/forms/User.vue'

export default {
  name: 'users',

  components: {
    UserForm,
  },

  data() {
    return {
      benched: 0,
      editedItem: this.item,
      height: 0,
      saving: false,
      showUserForm: false,
      snackbar: {
        show: false,
        color: '',
        message: '',
      },
      user: {},
      users: [],
    }
  },

  created() {
    this.getUsers()
  },

  computed: {
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$emit('close', 'the test')
        }
      },
    },
  },

  watch: {
    editedItem: {
      handler: function() {
        this.saving = true
      },
      deep: true,
    },
  },

  methods: {
    onResize() {
      this.height = window.innerHeight - 180
    },

    async getUsers() {
      const clientId = this.$store.state.client.id

      try {
        const response = await Api().get('users/' + clientId)

        this.users = response.data
      } catch (e) {
        console.error(e)
      }
    },

    addUser() {
      this.showUserForm = true
      this.user = {}
      this.user.status = true
    },

    editUser(id) {
      this.showUserForm = true
      this.user = _.find(this.users, { id })
    },

    async userStatus(userId, active) {
      try {
        let formData = {}
        formData.status = active

        const response = await Api().put('users/' + userId, formData)

        let objIndex = this.users.findIndex(obj => obj.id == userId)

        this.users[objIndex].status = active

        this.snackbar.message = response.data.message
        this.snackbar.color = 'success'
        this.snackbar.show = true
      } catch (e) {
        this.snackbar.message = e.response.data.error
        this.snackbar.color = 'error'
        this.snackbar.show = true
      }
    },

    closeThis() {
      this.showUserForm = false
      console.log('closing')
      this.getUsers()
    },
  },
}
</script>

<style></style>
